package kz.dentalcrm.app.core.utils

import kz.dentalcrm.app.data.network.response_model.employees.Employee

fun Employee.simplify(): String = "${this.surname} ${this.name?.firstOrNull()}.${
    if (this.patronymic.isNullOrEmpty()) ""
    else "${this.patronymic.firstOrNull()}."
}"